import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';

class SelectInputPOSLot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            error: ""
        }
    }

    onChange(event){
        this.setState(value)
        if (this.props.onChange != undefined) {
            this.props.onChange(value);
        }
    }

    render() {
        const e = this.state && this.state.error;
        const value = this.state && this.state.value;

        const { name, options, error, dispatch, ...textProps } = this.props;
        if (!options) return null;

        return (
            <FormControl fullWidth variant="standard" error={e && (this.state.value === undefined || this.state.value === '' || this.state.value == null)}>
                <InputLabel>{textProps.label}</InputLabel>
                <Select
                    name={name}
                    id={name}
                    value={value}
                    onChange={this.onChange}
                    label={textProps.label}
                >
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.packageReference}
                        </MenuItem>
                    ))}
                </Select>
                {e && (this.state.value === undefined || this.state.value === '' || this.state.value == null) && (
                    <FormHelperText>{error}</FormHelperText>
                )}
            </FormControl>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        //value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(SelectInputPOSLot);